import trendingUndergroundSagas from './lineups/tracks/sagas'

const sagas = () => [...trendingUndergroundSagas()]
export default sagas
